<!-- ============ GENERIC TABLE MODE ============ -->
<ng-container *ngIf="isGenericTableMode; else yearMode">
  <div class="generic-table-wrapper"
    [class.simulation-filters-widget]="widgetId === 'simulation-filters'"
    [class.simulation-values-widget]="widgetId === 'simulation-values'"
    [class.simulation-summary-widget]="widgetId === 'simulation-summary'">

    <ng-container *ngIf="!genericLoading; else genericLoader">
      <div class="generic-table-header-row" *ngIf="getTopActions().length > 0 && widgetId !== 'simulation-values'"
        [ngStyle]="getTopActionsContainerStyle()">
        <!-- Actions (Top Right) -->
        <div class="top-actions-bar">
          <button *ngFor="let action of getTopActions()" type="button" mat-raised-button
            [class]="getActionButtonClasses(action)" [attr.aria-current]="isActionRouteActive(action) ? 'page' : null"
            [disabled]="isActionDisabled(action)" (click)="handleGenericAction(action)">
            {{ action.label }}
          </button>
        </div>
      </div>

      <div class="generic-table-container" [class.clean-look]="data?.containerStyle === 'clean'"
        [class.simulation-values-table]="widgetId === 'simulation-values'"
        [class.simulation-summary-table]="widgetId === 'simulation-summary'" [ngStyle]="getTableContainerStyle()">
        <!-- Header Row (Title + Actions if Top) -->
        <div class="widget-title-container" *ngIf="data?.title && widgetId !== 'simulation-summary'">
          <h4 class="widget-title">{{ data.title }}</h4>
          <div class="top-actions-bar widget-title-actions"
            *ngIf="widgetId === 'simulation-values' && getTopActions().length > 0">
            <button *ngFor="let action of getTopActions()" type="button" mat-raised-button
              [class]="getActionButtonClasses(action)" [attr.aria-current]="isActionRouteActive(action) ? 'page' : null"
              [disabled]="isActionDisabled(action)" (click)="handleGenericAction(action)">
              {{ action.label }}
            </button>
          </div>
        </div>

        <ng-container *ngIf="widgetId === 'simulation-summary'; else genericTableLayout">
          <div class="summary-table-wrapper" [style.max-height]="getConfiguredTableHeight()">
            <ng-container *ngIf="genericTableData.length > 0; else emptySummaryState">
              <table class="summary-custom-table summary-section-table"
                     *ngFor="let section of getSummarySections()">
                <thead>
                  <tr class="summary-section-header-row">
                    <th class="summary-section-title-cell" colspan="2">{{ section.title }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of section.rows">
                    <td class="summary-metric-cell">{{ row.metric }}</td>
                    <td class="summary-value-cell">
                      {{ getGenericCellDisplayValue(row, { key: 'value', label: 'Value' }) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <ng-template #emptySummaryState>
              <div class="generic-loading-text">No summary data available.</div>
            </ng-template>
          </div>
        </ng-container>

        <ng-template #genericTableLayout>
          <div class="generic-table-horizontal-wrapper" [style.max-height]="getConfiguredTableHeight()">
            <table class="generic-custom-table" [class.no-filter-row]="data?.hideColumnFilters">
              <thead class="generic-table-header">

                <!-- Row 1: Labels -->
                <tr class="generic-label-row top-row" *ngIf="shouldShowGenericLabelRow()">
                  <th *ngIf="data?.isMultiSelect" class="checkbox-column-header">
                    <span class="column-label">Select</span>
                  </th>
                  <th *ngFor="let col of genericColumns" [style.width.px]="col.width">
                    <span class="column-label">{{ col.label }}</span>
                  </th>
                  <th *ngIf="data?.showRowEditIcon" class="action-column-header">Edit</th>
                </tr>

                <!-- Row 2: Filters / Totals -->
                <tr class="generic-filter-row bottom-row" *ngIf="!data?.hideColumnFilters">
                  <th *ngIf="data?.isMultiSelect" class="checkbox-column-header">
                    <div class="generic-column-filter checkbox-filter">
                      <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)" />
                    </div>
                  </th>
                  <th *ngFor="let col of genericColumns" [style.width.px]="col.width">
                    <div class="generic-column-filter input-cell" style="display: flex; align-items: center; gap: 8px;">
                      <!-- Total Display or Filter Input -->
                      <div class="input-wrapper"
                        style="background: white; border-radius: 4px; padding: 2px; display: flex; align-items: center; width: 100%;">
                        <!-- If showing total OR single row selection -->
                        <div *ngIf="headerTotals[col.key]" class="total-display"
                          style="width: 100%; color: black; font-weight: bold; padding-left: 5px; text-align: left;">
                          {{ headerTotals[col.key] }}
                        </div>
                        <!-- Else show filter input -->
                        <input *ngIf="!headerTotals[col.key]" type="text" [placeholder]="''"
                          [value]="filterValues[col.key] || ''" (input)="onFilterInput(col.key, $event)"
                          style="border: none; outline: none; width: 100%; padding: 4px;" />
                      </div>
                      <!-- Filter Icon (Outside wrapper) -->
                      <mat-icon *ngIf="col.isFilterable" class="generic-filter-icon"
                        style="color: white; cursor: pointer; font-size: 18px; width: 18px; height: 18px;"
                        [class.active-filter]="selectedFilterValues[col.key] && selectedFilterValues[col.key].size > 0"
                        [matMenuTriggerFor]="filterMenu" (click)="$event.stopPropagation()">
                        filter_list
                      </mat-icon>

                      <!-- Filter Menu (Same as before) -->
                      <mat-menu #filterMenu="matMenu" class="excel-filter-menu" [overlapTrigger]="false">
                        <div (click)="$event.stopPropagation()" class="filter-menu-container">
                          <div class="filter-search-box">
                            <input type="text" placeholder="Search..." (input)="onFilterSearch(col.key, $event)" />
                          </div>
                          <div class="filter-option select-all-option">
                            <input type="checkbox" id="sel-all-{{col.key}}" [checked]="isAllFilterSelected(col.key)"
                              (change)="toggleFilterSelectAll(col.key, $event)" />
                            <label for="sel-all-{{col.key}}">Select All</label>
                          </div>
                          <div class="filter-options-list">
                            <div *ngFor="let val of getFilteredOptions(col.key)" class="filter-option">
                              <input type="checkbox" id="opt-{{col.key}}-{{val}}"
                                [checked]="isFilterSelected(col.key, val)" (change)="toggleFilterValue(col.key, val)" />
                              <label for="opt-{{col.key}}-{{val}}">{{ val }}</label>
                            </div>
                          </div>
                          <div class="filter-actions">
                            <button mat-button (click)="clearColumnFilter(col.key)">Clear</button>
                            <button mat-raised-button color="primary" (click)="applyColumnFilter(col.key)">Apply</button>
                          </div>
                        </div>
                      </mat-menu>
                    </div>
                  </th>
                  <th *ngIf="data?.showRowEditIcon" class="action-column-header action-column-filter-header">
                    <div class="action-column-button">
                      <button mat-flat-button color="warn" type="button" class="delete-header-btn"
                        [disabled]="selectedRows.size === 0" (click)="deleteSelectedRows()"
                        aria-label="Delete selected rows">
                        Delete
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let row of genericTableData">
                  <td *ngIf="data?.isMultiSelect" class="checkbox-column-cell">
                    <input type="checkbox" [checked]="selectedRows.has(row)" (change)="toggleSelection(row)" />
                  </td>
                  <td *ngFor="let col of genericColumns" [style.width.px]="col.width">
                    <ng-container
                      *ngIf="(data?.isEditable || row.isEditing) && col.isEditable !== false; else genericViewMode">
                      <ng-container *ngIf="col.type === 'dropdown' && !row.allowManualEntry; else genericTextInput">
                        <mat-form-field appearance="outline" class="dropdown-field">
                          <mat-select [disabled]="getDropdownOptions(row, col).length === 0" [value]="row[col.key]"
                            (openedChange)="onDropdownOpenedChange(row, col.key, $event, searchInput)"
                            (selectionChange)="onDropdownValueChange(row, col.key, $event.value)">
                            <mat-option class="dropdown-search-option" disabled>
                              <input #searchInput class="dropdown-search-input" type="text" placeholder="Search options"
                                [ngModel]="getDropdownSearchTerm(row, col.key)"
                                (ngModelChange)="onDropdownSearchChange(row, col.key, $event)"
                                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
                            </mat-option>
                            <mat-option value="" disabled>Select...</mat-option>
                            <mat-option *ngFor="let opt of getFilteredDropdownOptions(row, col)" [value]="opt">
                              {{ getDropdownOptionLabel(row, col, opt) }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
                      <ng-template #genericTextInput>
                        <div class="price-change-input-wrapper" [class.has-info]="row.property === 'Price Change Value'">
                          <input type="text" class="generic-table-input" [class.manual-entry-input]="row.allowManualEntry"
                            [placeholder]="row.property === 'Price Change Value' ? 'Enter value' : ''"
                            [ngModel]="row[col.key]" (ngModelChange)="onGenericTextValueChange(row, col.key, $event)" />
                          <button *ngIf="row.property === 'Price Change Value'" type="button"
                            class="price-change-info-button" [matTooltip]="priceChangeValueInfoMessage"
                            matTooltipPosition="above" (click)="$event.preventDefault(); $event.stopPropagation()">
                            i
                          </button>
                        </div>
                      </ng-template>
                    </ng-container>
                    <ng-template #genericViewMode>
                      <div *ngIf="col.type === 'link'; else defaultCell" class="generic-view-mode-cell link-cell"
                        (click)="onCellClick(row, col)" style="cursor: pointer;">
                        {{ getGenericCellDisplayValue(row, col) }}
                      </div>
                      <ng-template #defaultCell>
                        <div class="generic-view-mode-cell">{{ getGenericCellDisplayValue(row, col) }}</div>
                      </ng-template>
                    </ng-template>
                  </td>
                  <!-- Row Action Cell -->
                  <td *ngIf="data?.showRowEditIcon" class="action-column-cell">
                    <ng-container *ngIf="!row.isEditing">
                      <mat-icon class="row-edit-icon" (click)="onRowEdit(row)" matTooltip="Edit Row">edit</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="row.isEditing">
                      <mat-icon class="row-save-icon" (click)="onRowSave(row)" matTooltip="Save"
                        style="color: green; cursor: pointer; margin-right: 8px;">check</mat-icon>
                      <mat-icon class="row-cancel-icon" (click)="onRowCancel(row)" matTooltip="Cancel"
                        style="color: red; cursor: pointer;">close</mat-icon>
                    </ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </div>
    </ng-container>

    <ng-template #genericLoader>
      <p class="generic-loading-text">Loading table...</p>
    </ng-template>

    <!-- Actions (Bottom - Default) -->
    <div class="simulation-filters-inline-actions"
      *ngIf="widgetId === 'simulation-filters' && !data?.showAppliedFilters">
      <button type="button" class="simulation-inline-btn simulation-inline-btn-secondary"
        (click)="handleGenericAction({ action: 'reset', label: 'Reset' })">
        Reset
      </button>
      <button *ngFor="let action of getBottomActions()" type="button"
        class="simulation-inline-btn simulation-inline-btn-primary" (click)="handleGenericAction(action)">
        {{ action.label }}
      </button>
    </div>

    <div class="bottom-actions-bar" *ngIf="getBottomActions().length > 0 && widgetId !== 'simulation-filters'"
      [ngStyle]="getBottomActionsContainerStyle()">
      <button *ngFor="let action of getBottomActions()" type="button" mat-raised-button
        [class]="getActionButtonClasses(action)" [attr.aria-current]="isActionRouteActive(action) ? 'page' : null"
        [disabled]="isActionDisabled(action)" (click)="handleGenericAction(action)">
        {{ action.label }}
      </button>
    </div>

    <!-- Applied Filters Section -->
    <div *ngIf="data?.showAppliedFilters" class="applied-filters-section">
      <div class="applied-filters-header-row">
        <h4 class="applied-filters-header">Applied Filters</h4>
        <div class="applied-filters-actions" *ngIf="widgetId === 'simulation-filters'">
          <button *ngFor="let action of getBottomActions()" type="button"
            class="simulation-inline-btn simulation-inline-btn-primary" (click)="handleGenericAction(action)">
            {{ action.label }}
          </button>
        </div>
        <!-- <button *ngIf="widgetId !== 'simulation-filters'" type="button" class="simulation-inline-btn simulation-inline-btn-secondary"
          (click)="toggleAppliedFiltersEditMode()">
          {{ appliedFiltersEditMode ? 'Done' : 'Edit' }}
        </button> -->
        <button
          *ngIf="widgetId === 'simulation-filters' && appliedFiltersEditMode && appliedFilters.length > 0"
          type="button"
          class="simulation-inline-btn simulation-inline-btn-secondary"
          (click)="clearAllAppliedFilters()">
          Clear All
        </button>
      </div>
      <div class="applied-filters-body" style="position: relative;">
        <div class="applied-filters-list">
          <div *ngFor="let filter of appliedFilters; let index = index" class="applied-filter-item">
            <span class="applied-filter-text">{{ filter }}</span>
            <button *ngIf="appliedFiltersEditMode" type="button" class="applied-filter-remove-btn"
              (click)="removeAppliedFilter(index)" aria-label="Remove applied filter">
              -
            </button>
          </div>
        </div>
        <button *ngIf="widgetId === 'simulation-filters'" type="button" class="simulation-inline-btn simulation-inline-btn-secondary"
          style="position: absolute; bottom: 12px; right: 12px; z-index: 10; margin: 0; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"
          (click)="toggleAppliedFiltersEditMode()">
          {{ appliedFiltersEditMode ? 'Done' : 'Edit' }}
        </button>
      </div>
    </div>

    <!-- Back and Save Buttons (shown only for simulation-summary) -->
    <div class="summary-footer-actions" *ngIf="widgetId === 'simulation-summary'">
      <button class="summary-back-btn" (click)="goBack()">Back</button>
      <button class="summary-save-btn" (click)="handleDirectSave()">Save</button>
    </div>
  </div>
</ng-container>

<!-- ============ YEAR-BASED MODE (Original) ============ -->
<ng-template #yearMode>
  <div class="chart-and-inputs">
    <div class="chart-wrapper">
      <!-- Reserved for chart if needed -->
    </div>

    <div class="aligned-inputs">
      <div class="label-col">
        <div class="row-label">Year</div>
        <div class="row-label">Opportunity %</div>
        <div class="row-label">Yearly Sales ($)</div>
        <div class="row-label">Notes</div>
      </div>

      <div class="input-cols" [ngStyle]="{
      'grid-template-columns': 'repeat(' + (yearRange.length+1) + ', 1fr)'
    }">
        <div class="input-col"></div>
        <div class="input-col" *ngFor="let year of yearRange;let i=index">

          <div><strong>{{years[i+1]}}</strong></div>

          <!-- Opportunity % -->
          <input *ngIf="form.get('opportunity_' + year)" type="number" [formControl]="getControl('opportunity_' + year)"
            (blur)="onOpportunityChange(year)" (keydown.enter)="onOpportunityEnter(year, $event)" />

          <!-- Yearly Sales -->
          <input *ngIf="form.get('sales_' + year)" type="text"
            [value]="getControl('sales_' + year) ? formatValueInMillions(getControl('sales_' + year).value, { preserveCurrency: true }) : ''"
            disabled placeholder="Yearly Sales" />

          <!-- Notes -->
          <textarea *ngIf="form.get('notes_' + year)" [formControl]="getControl('notes_' + year)" placeholder="Notes"
            (keydown.enter)="onEnter(year, $event)"></textarea>
        </div>
      </div>
      <!-- Action Buttons -->
      <div class="button-col">
        <!-- <button class="recalculate" (click)="onRecalculate()" [disabled]="isLoading || areActionsDisabled" matTooltip="Check if the calculated final price exceeds the actual final price." matTooltipPosition="left">Validate</button> -->
        <button class="submit" (click)="onSubmit()" [disabled]="isLoading || areActionsDisabled"
          matTooltip="Save the updated Opportunity % changes." matTooltipPosition="left">Submit</button>
        <button class="cancel" (click)="onCancel()" [disabled]="areActionsDisabled"
          matTooltip="Discard any unsubmitted Opportunity % changes." matTooltipPosition="left">Cancel</button>
        <button class="cancel" (click)="onReset()" [disabled]="areActionsDisabled"
          matTooltip="Revert Opportunity % changes to their original values." matTooltipPosition="left">Reset</button>
      </div>
    </div>

    <!-- Spinner and Messages -->
    <div class="status-container">
      <mat-progress-spinner *ngIf="isLoading" mode="indeterminate" [diameter]="30"></mat-progress-spinner>

      <div *ngIf="successMessage" class="success-message">
        {{ successMessage }}
        <button class="close-btn" (click)="clearMessages()">×</button>
      </div>

      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
        <button class="close-btn" (click)="clearMessages()">×</button>
      </div>
    </div>
  </div>
</ng-template>

<div class="run-window-freeze-overlay" *ngIf="isRunWindowFrozen">
  <mat-progress-spinner mode="indeterminate" [diameter]="42" color="primary"></mat-progress-spinner>
  <span>Processing...</span>
</div>
